"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("color:inherit;cursor:pointer;line-height:", theme.lineHeight.leadingNormal, ";font-size:", theme.fontSize.base, ";font-weight:", theme.fontWeight.normal, ";&:first-of-type{margin-left:0;}&:last-of-type{margin-right:0;}&:hover{color:", theme.color.tabs.tabActiveText, ";}&:disabled{opacity:0.5;cursor:default;pointer-events:none;}" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var smallTabActive = function smallTabActive(theme) {
  return /*#__PURE__*/(0, _react.css)("border-color:currentColor;background-color:", theme.color.monochrome.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:smallTabActive;"));
};

var bigTabActive = function bigTabActive(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.tabs.tabActiveText, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:bigTabActive;"));
};

var big = function big(theme, active) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";margin:0 ", theme.spacing[5], ";padding:0 ", theme.spacing[5], ";transition:color 0.2s;", active && bigTabActive(theme), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:big;"));
};

var small = function small(theme, active) {
  return /*#__PURE__*/(0, _react.css)(base(theme), ";border:1px solid transparent;margin:0 ", theme.spacing[3], ";padding:", theme.spacing[3], " ", theme.spacing[7], ";font-size:", theme.fontSize.xsmall, ";font-weight:", theme.fontWeight.medium, ";border-radius:", theme.spacing[3], ";transition:border-color 0.3s,background-color 0.3s;", active && smallTabActive(theme), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:small;"));
};

var types = {
  big: big,
  small: small
};

var tab = function tab(_ref) {
  var theme = _ref.theme,
      active = _ref.active,
      tabType = _ref.tabType;
  return /*#__PURE__*/(0, _react.css)(types[tabType](theme, active), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:tab;"));
};

var styles = {
  tab: tab
};
exports.styles = styles;
//# sourceMappingURL=Tab.styles.js.map